import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarImageIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M15.83 1.67H4.17a2.5 2.5 0 0 0-2.5 2.5v11.66a2.5 2.5 0 0 0 2.5 2.5h11.66c.14 0 .28-.01.41-.04l.25-.06h.1l.31-.11.1-.06.27-.15.31-.27.06-.07.23-.27.07-.1.15-.3a.85.85 0 0 0 .06-.13l.1-.31v-.13c.05-.16.08-.33.08-.5V4.17a2.5 2.5 0 0 0-2.5-2.5Zm-11.66 15a.83.83 0 0 1-.84-.84v-3.59L6.07 9.5a.83.83 0 0 1 1.19 0l7.17 7.18H4.17Zm12.5-.84c0 .1-.02.2-.06.3a.83.83 0 0 1-.14.22L12 11.89l.73-.73a.83.83 0 0 1 1.19 0l2.74 2.75v1.92Zm0-4.28L15.1 10a2.57 2.57 0 0 0-3.53 0l-.74.73-2.4-2.4a2.57 2.57 0 0 0-3.53 0L3.33 9.88V4.17a.83.83 0 0 1 .84-.84h11.66a.83.83 0 0 1 .84.84v7.38ZM11.25 5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
      fill="#5C64ED"
    />
    <path
      d="M15.83 1.67H4.17a2.5 2.5 0 0 0-2.5 2.5v11.66a2.5 2.5 0 0 0 2.5 2.5h11.66c.14 0 .28-.01.41-.04l.25-.06h.1l.31-.11.1-.06.27-.15.31-.27.06-.07.23-.27.07-.1.15-.3a.85.85 0 0 0 .06-.13l.1-.31v-.13c.05-.16.08-.33.08-.5V4.17a2.5 2.5 0 0 0-2.5-2.5Zm-11.66 15a.83.83 0 0 1-.84-.84v-3.59L6.07 9.5a.83.83 0 0 1 1.19 0l7.17 7.18H4.17Zm12.5-.84c0 .1-.02.2-.06.3a.83.83 0 0 1-.14.22L12 11.89l.73-.73a.83.83 0 0 1 1.19 0l2.74 2.75v1.92Zm0-4.28L15.1 10a2.57 2.57 0 0 0-3.53 0l-.74.73-2.4-2.4a2.57 2.57 0 0 0-3.53 0L3.33 9.88V4.17a.83.83 0 0 1 .84-.84h11.66a.83.83 0 0 1 .84.84v7.38ZM11.25 5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1="1.67"
        x2="10"
        y2="18.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarImageIcon.defaultProps = {
  sx: null,
}
